<template>
  <div>
    <el-table
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      stripe
      :data="classeList"
      border
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="title"
        label="班级"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="headTeacherName"
        label="班主任姓名"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="studentNums"
        label="已加入学生"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="parentNums"
        label="已加入家长"
      ></el-table-column>

      <!-- 操作 -->
      <el-table-column
        label="操作"
        width="400"
        header-align="center"
        align="center"
        v-if="authSource == 'system'"
      >
        <template v-slot="scope">
          <el-button
            type="text"
            class="text_btn"
            size="small"
            @click="updateClasses(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" size="small" @click="addCharge(scope.row)"
            >设置班主任</el-button
          >
          <el-button
            type="text"
            v-show="scope.row.headTeacherId"
            size="small"
            @click="cancleTeacher(scope.row)"
            >取消班主任</el-button
          >
          <!-- <el-button
            @click="onDelClass(scope.row.id)"
            v-show="scope.row.last"
            style="color: red"
            type="text"
            size="small"
            >删除</el-button
          > -->
          <el-button
            @click="onDelClass(scope.row.id)"
            style="color: red"
            type="text"
            size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <!-- <el-pagination
      background
      layout="prev, pager, next, jumper"
      :page-sizes="[20, 40]"
      :page-size="pageSize"
      :total="totalCount"
      @current-change="currentChange"
    ></el-pagination> -->
    <!-- 添加班主任弹出框 -->
    <el-dialog
      title="设置班主任"
      class="tt_dialog"
      :visible.sync="dialogTableVisible"
      width="55%"
    >
      <el-form :inline="true" :model="teacher">
        <el-form-item label="姓名">
          <el-input
            v-model="teacher.name"
            size="small"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input
            v-model="teacher.mobile"
            size="small"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="teacherLists"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :row-style="{ height: '48px' }"
        :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
        :data="teachersList"
        stripe
        height="650"
      >
        <el-table-column
          property="name"
          label="教师姓名"
          width="300"
          align="center"
        ></el-table-column>
        <el-table-column
          property="mobile"
          label="教师手机号"
          width="300"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="addCharges(scope.row)"
              >设置为班主任</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-bottom: 20px"
        background
        layout="total,prev,pager,next,sizes"
        :total="teacher.totalCount"
        :page-size="teacher.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="teacher.curPage"
        @current-change="currentChanges"
        @size-change="handleSizeChange"
      ></el-pagination>
    </el-dialog>
    <el-dialog title="编辑班级" :visible.sync="dialog" width="55%">
      <el-form :model="classlists" label-width="100px">
        <el-form-item label="班级名称">
          <el-input
            v-model="classlists.name"
            size="small"
            style="width: 170px"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="班级序号">
          <el-input
            v-model.number="classlists.num"
            maxlength="20"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            size="small"
            style="width: 170px"
          ></el-input>
        </el-form-item>
        <el-form-item label="班级群二维码">
          <div>
            <el-upload
              class="avatar-uploader"
              :show-file-list="false"
              :action="`${urlss}/file/oss-upload`"
              list-type="picture-card"
              :headers="headers"
              :on-success="successHandlerLogo"
              accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,"
              :before-upload="beforeUpload"
            >
              <img
                :src="'http://file.jingshidata.com/' + classlists.url"
                class="avatar"
                v-if="classlists.url != ''"
              />
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="baocun"
            style="float: right"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  classesList,
  teacherLists,
  classSetTeacher,
  cancleTeacher,
  updateClasses,
  delLastClass,
} from '@/api/home'
import { urls } from '@/api/notice'
export default {
  data() {
    return {
      authSource: '',
      // 每页显示条数
      pageSize: 20,
      urlss: urls,
      // 页码
      curPage: 1,
      dialog: false,
      headers: {
        token: localStorage.getItem('token'),
      },
      // 数据总条数
      totalCount: 1,
      // 班级数据
      classeList: [],
      //   是否打开添加班主任弹出框
      dialogTableVisible: false,
      //   取消班主任是否隐藏
      headTeacher: true,
      // 教师
      teacher: {
        // 页码
        curPage: 1,
        // 每页显示条数
        pageSize: 20,
        // 数据总条数
        totalCount: 1,
        // 姓名
        name: '',
        // 手机号
        mobile: '',
      },
      classlists: {
        name: '',
        url: '',
        num: '',
      },
      class: '',
      //   教师列表
      teachersList: [],
      classesName: '',
      //   班级ID
      classID: 0,
      //   教师ID
      teacherID: 0,
      schoolId: localStorage.getItem('schoolIds'),
      getClassesParam: {},
    }
  },
  // 接受父组件传值
  props: {
    gradeId: {
      type: String,
      required: true,
      totalCount: 1,
    },
  },
  // 初始化
  created() {
    this.authSource = localStorage.getItem('authSource')
    this.getClassesParam = {
      curPage: this.curPage,
      pageSize: this.pageSize,
      schoolId: this.schoolId,
      gradeId: this.gradeId,
    }
    console.log(this.getClassesParam)
    this.classesList()
  },
  watch: {
    gradeId: function (val, oldVal) {
      this.classesList()
    },
  },
  methods: {
    // 删除最后一个班级
    onDelClass(id) {
      console.log('del', id)
      this.$confirm(`该操作将永久性删除此条数据！`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          delLastClass(id)
            .then((res) => {
              let { code } = res.data
              if (code == 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功',
                })
                // 拉数据
                this.classesList()
              }
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (file.type.indexOf('image/') == -1) {
        this.$message({
          type: 'error',
          message: '文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。',
        })
        return false
      }
      return true
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
    },

    // 上传图片成功
    successHandlerLogo(response, file, fileList) {
      // 保存图片到原始数据中
      this.classlists.url = response.data[0].fileName
    },
    //   获取班级列表
    async classesList() {
      //   var gradeId = parseInt(this.gradeId)
      try {
        const { data: res } = await classesList({
          schoolId: this.schoolId,
          // curPage: this.curPage,
          // pageSize: this.pageSize,
          gradeId: this.gradeId,
        })
        // console.log('res.data', res.data)
        this.classeList = res.data.dataList
        this.totalCount = res.data.totalCount
        // console.log(this.classeList)
      } catch (err) {
        console.log(err)
      }
    },

    async teacherLists() {
      try {
        const { data: res } = await teacherLists({
          curPage: this.teacher.curPage,
          schoolId: this.schoolId,
          name: this.teacher.name,
          mobile: this.teacher.mobile,
          pageSize: this.teacher.pageSize,
        })
        // console.log(res.data)
        this.teachersList = res.data.dataList
        this.teacher.totalCount = res.data.totalCount
        console.log('teachersList', this.teachersList)
      } catch (err) {}
    },

    // 分页页码变化
    currentChanges(e) {
      this.teacher.curPage = e
      // 调用查询教师列表
      this.teacherLists()
    },

    handleSizeChange(val) {
      this.teacher.curPage = 1
      this.teacher.pageSize = val
      this.teacherLists()
    },

    // 获得班级ID
    addCharge(item) {
      this.dialogTableVisible = true
      this.classID = item.id
      this.classesName = item.title
      this.teacherLists()
    },
    // 取消班主任
    async cancleTeacher(row) {
      this.$confirm(
        `您确定要解除<span style="color:#409EFF;margin:0 10px;"> ${
          row.title + ' ' + row.headTeacherName
        } </span>班主任的身份吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          cancleTeacher({
            classesId: row.id,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '取消成功',
            })
            this.classesList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
      // const confirResult = await this.$confirm(
      //   '此操作将此老师取消为该班班主任, 是否取消?',
      //   '提示',
      //   {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning',
      //   }
      // ).catch((err) => err)
      // if (confirResult !== 'confirm') {
      //   return this.$message.info('已取消添加操作！！')
      // }

      // try {
      //   const { data: res } = await cancleTeacher({
      //     classesId: row.id,
      //   })
      //   this.$message.success(res.msg)
      // } catch (err) {
      //   console.log(err)
      // }
      //   调用班级列表接口
      // this.classesList()
    },
    // 页码变化时，触发classList函数
    currentChange(e) {
      this.curPage = e
      this.classesList()
    },

    // 设置班级班主任
    async classSetTeacher() {
      try {
        const { data: res } = await classSetTeacher({
          classesId: this.classID,
          teacherId: this.teacherID,
        })
        this.$message.success(res.msg)
      } catch (err) {
        console.log(err)
      }
      //   调用班级列表接口
      this.classesList()
    },
    // 获取教师ID，并设置班主任
    async addCharges(row) {
      this.teacherID = row.id
      // 调用设置班主任接口
      this.$confirm(
        `您确定要设置<span style="color:#409EFF;margin:0 10px;"> ${
          row.name + '为' + this.classesName
        } </span>为班主任的吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          cancleTeacher({ classesId: row.id }).then(() => {
            this.classSetTeacher()
            // this.$message({
            //   type: 'success',
            //   message: '设置成功'
            // })
            this.dialogTableVisible = false
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消设置',
          })
        })
    },

    updateClasses(row) {
      this.class = row
      this.classlists.url = row.classsQrcodeUrl
      this.classlists.name = row.title
      this.classlists.num = row.num
      this.dialog = true
    },
    baocun() {
      let that = this
      let params = {
        fileUrl: this.classlists.url,
        schoolId: this.class.schoolId,
        gradeNum: this.class.gradeNum,
        num: this.classlists.num,
        gradeId: this.class.gradeNum,
        id: this.class.id, //班级ID
        title: this.classlists.name, //班级名称
      }
      this.loading = true
      updateClasses(params)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: 'success',
              message: '保存成功',
            })
            this.dialog = false
            this.classesList()
          }
        })
        .catch((err) => {
          that.loading = false
          this.$message({
            type: 'error',
            message: '保存失败',
          })
        })
    },
  },
}
</script>
<style scoped>
/* .el-form-item {
  width: 260px;
  float: left;
} */
.el-input {
  width: 100%;
}
.el-button + .el-button {
  margin-left: 20px;
}
.text_btn {
  margin-left: 30px;
}
.avatar {
  height: 170px;
}
.avatar-uploader > .el-upload--picture-card {
  height: 170px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/components/ClassesTable.vue